module.exports = __webpack_public_path__ + "img/funda_onto_seal.7c590ec5.png";